import http from "../common/api";
import { ApiSettings } from "application";
import { getStep2FormData } from "./adapter";

const create = async (data) => {
  const formData = getStep2FormData(data);

  return await http.post(ApiSettings.savePersonalAndBillFile, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export default create;
